export default {
  methods: {
    // {{ organization.phone }}  or  {{ city }}
    renderTemplate (txt) {
      return txt.replace(/{{\s*([\w.]+)\s*}}/g, (_, p) =>
        this.$resolveToken(p)
      )
    },
    $resolveToken (path) {
      let ctx = path.startsWith('organization.')
        ? this.organization
        : this
      path = path.replace(/^organization\./, '')
      for (const key of path.split('.')) {
        ctx = ctx?.[key]
        if (ctx == null) break
      }
      return typeof ctx === 'function' ? ctx() : ctx ?? ''
    }
  }
}
